import { FunctionalComponent, h } from '@stencil/core';

type Props = { value: number; }

export const CountdownComponent: FunctionalComponent<Props> = ({ value }, children) => (
  <div class="countdown-component no-shrink">
    <div class="countdown-big no-wrap">{pad(value)}</div>
    <div class="countdown-small no-wrap">{children}</div>
  </div>
);

function pad(num: number): string {
  return `${num}`.padStart(2, '0');
}
